import { ColumnOutputType } from 'app/component-library/table/column-output-type';
import { TableColumn } from '../../../../component-library/table/table-column';
import { TableConfig } from '../../../../component-library/table/table-config';
import { CONFIG } from '../../../../core/config';
import { Widget } from '../../../../viewmodels/dashboard/widget';
import { WidgetParameter } from '../../../../viewmodels/dashboard/widget-parameter';
import { DisplayData } from '../bar/DisplayData';
import { ValueSource } from '../widget-parameters/value-source.enum';
import { ValueType } from '../widget-parameters/value-type.enum';
import { ItemizedWidgetData } from './itemized-widget-data';

export class AssetCountItemizedWidgetData extends ItemizedWidgetData {
  public createTableConfig(): TableConfig {
    const tableConfig = super.initializeTableConfig();
    tableConfig.columns = this.createColumns();
    return tableConfig;
  }

  public setFilterParameter(widget: Widget, widgetParam: WidgetParameter, reset: boolean) {
    const paramIndex = widget.widgetItemizedDataParameters.findIndex(w => w.valueSource === ValueSource.HierarchyTemplateName);

    if (paramIndex > -1) {
      if (!reset) {
        widget.widgetItemizedDataParameters[paramIndex] = widgetParam;
        return;
      }
      widget.widgetItemizedDataParameters.splice(paramIndex, 1);
      return;
    }
    if (!reset && widgetParam.valueSource === ValueSource.HierarchyTemplateName) {
      widget.widgetItemizedDataParameters.push(widgetParam);
    }
  }

  protected createColumns(): TableColumn[] {
    const assetNameColumn = new TableColumn('Asset Name', 'AssetName');
    assetNameColumn.outputType = ColumnOutputType.Link;
    assetNameColumn.linkClickEvent = this.navigateToHierarchyItem;
    const templateNameColumn = new TableColumn('Template Name', 'TemplateName');

    return [assetNameColumn, templateNameColumn];
  }

  public createOverallTableHeaderColumn(): TableColumn {
    const headerColumn = new TableColumn('Template Name', 'label');
    headerColumn.outputType = ColumnOutputType.Link;
    headerColumn.linkClickEvent = this.assetCountDrillDown;
    return headerColumn;
  }

  private assetCountDrillDown = (data: DisplayData) => {
    const widgetParam = new WidgetParameter();
    widgetParam.widgetId = data.widgetId;
    widgetParam.valueSource = ValueSource.HierarchyTemplateName;
    widgetParam.valueType = ValueType.String;
    widgetParam.displayName = data.label;
    widgetParam.stringValue = data.label;
    this.viewDataTableService.setItemizedDataWidgetParam.next(widgetParam);
  };

  private navigateToHierarchyItem = (data: any) => {
    if (data.HierarchyItemId) {
      this.router.navigate([this.authService.urlCatalog + CONFIG.routes.hierarchy.item.root(data.HierarchyItemId)]);
    }
  };
}
